import { useState } from "react";
import TorkPicker from "./TorkPicker";
import ApproveDenyModal from "../../components/RootElements/ApproveDenyModal";

const toLocalDatetime = (isoStr) => {
    if (!isoStr) return "";
    const d = new Date(isoStr);
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

/* Modal for re-torking an order.
   Lets the user pick a new klar datum, edit Dim/Fukt, and optionally change the tork,
   then confirms with an "Are you sure?" step before submitting. */
const OmtorkModal = ({ order, torks, noteTypes, onSubmit, onClose }) => {
    const [dryFinished, setDryFinished] = useState(toLocalDatetime(order.dates?.dryFinished));
    const [torkId, setTorkId] = useState(order.torkId || null);
    const [showTorkPicker, setShowTorkPicker] = useState(false);
    const [confirming, setConfirming] = useState(false);

    const selectedTork = torks.find(t => t.id === torkId);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (!dryFinished) return;
        setConfirming(true);
    };

    const handleConfirm = () => {
        onSubmit(order.id, {
            dryFinished: new Date(dryFinished).toISOString(),
            torkId,
        });
    };

    return (
        <>
        <div
            className="fixed inset-0 bg-black/40 flex items-center justify-center z-40 p-4"
            onClick={onClose}
        >
            <form
                onSubmit={handleFormSubmit}
                className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto p-6"
                onClick={e => e.stopPropagation()}
            >
                <h2 className="text-xl font-semibold mb-1">Omtorka order</h2>
                <p className="text-sm text-gray-500 mb-5">
                    Order {order.orderId} · {order.type}
                </p>

                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Nytt klar datum *
                </label>
                <input
                    type="datetime-local"
                    className="input mb-4 w-full"
                    value={dryFinished}
                    onChange={e => setDryFinished(e.target.value)}
                    required
                />

                <div className="grid grid-cols-2 gap-3 mb-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Dim</label>
                        <p className="text-sm text-gray-800">{order.package?.dimension || "–"}</p>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Fukt</label>
                        <p className="text-sm text-gray-800">{order.package?.moisture || "–"}</p>
                    </div>
                </div>

                <label className="block text-sm font-medium text-gray-700 mb-1">Tork</label>
                <button
                    type="button"
                    onClick={() => setShowTorkPicker(true)}
                    className="input text-left w-full text-gray-700 hover:bg-gray-50 mb-6"
                >
                    {selectedTork
                        ? selectedTork.name
                        : <span className="text-gray-400">Välj tork…</span>}
                </button>

                <div className="flex justify-end gap-2">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100"
                    >
                        Avbryt
                    </button>
                    <button
                        type="submit"
                        className="px-4 py-2 rounded-lg text-white font-medium"
                        style={{ backgroundColor: "#d97706" }}
                    >
                        Omtorka
                    </button>
                </div>
            </form>
        </div>

        {showTorkPicker && (
            <TorkPicker
                torks={torks}
                noteTypes={noteTypes}
                value={torkId}
                onChange={(id) => setTorkId(id)}
                onClose={() => setShowTorkPicker(false)}
                title="Välj tork för omtorkning"
            />
        )}

        {confirming && (
            <ApproveDenyModal
                onAccept={handleConfirm}
                onDeny={() => setConfirming(false)}
            >
                Är du säker på att du vill omtorka ordern? Status återställs till "Pågående" med det nya klar datumet.
            </ApproveDenyModal>
        )}
        </>
    );
};

export default OmtorkModal;
